import axios, { AxiosError } from 'axios';

export const axiosClient = axios.create({
	baseURL: process.env.REST_URL,
	headers: {
		'Content-Type': 'application/json',
		Accept: 'application/json'
	}
});

export const updateAuthHeader = (token?: string | undefined) => {
	try {
		if (!token) {
			delete axiosClient.defaults.headers.common['Authorization'];
		} else {
			axiosClient.defaults.headers.common.Authorization = `Bearer ${token}`;
		}
	} catch (err) {
		console.error('updateAuthHeader', err);
	}
};

export function isAxiosError<ResponseType>(error: unknown): error is AxiosError<ResponseType> {
	return axios.isAxiosError(error);
}
